import React, { useState, useEffect } from "react";
import Credin from "../../assets/Credin Logo (1).svg";
import { useNavigate } from "react-router-dom";

const translations = {
  ENGLISH: {
    companyBusinessPriority: "Company / Business Priority",
    select: "Select",
    high: "High",
    moderate: "Moderate",
    low: "Low",
    companyBusinessDescription: "Company / Business Description",
    visitConducted: "Visit Conducted",
    yes: "Yes",
    no: "No",
    addressConfirmation: "Address Confirmation",
    ifAddressNotConfirm: "If Address Not Confirm",
    addressTrace: "Address Trace",
    easy: "Easy",
    notEasy: "Not Easy",
    landmark: "Landmark",
    metPersonName: "Met Person Name",
    metPersonRelation: "Met Person Relation",
    ownership: "Ownership",
    ownedByApplicant: "Owned By Applicant",
    parental: "Parental",
    rented: "Rented",
    married: "Married",
    unmarried: "Unmarried",
    zero: "0",
    one: "1",
    two: "2",
    three: "3",
    four: "4",
    fiveAndAbove: "5 & Above",
    ifRented: "If Rented (Rent Amt. & Landlord Name)",
    stabilityYears: "Stability Years",
    maritalStatus: "Marital Status",
    child: "Child",
    totalMembers: "Total Members",
    earningMembers: "Earning Members",
    spouseName: "Spouse Name",
    standardOfLiving: "Select Standard Of Living",
    average: "Average",
    seen: "Seen",
    notSeen: "Not Seen",
    namePlate: "Name Plate",
    totalRoom: "Total Room",
    oneBHK: "1 BHK",
    twoBHK: "2 BHK",
    threeBHK: "3 BHK",
    fourBHK: "4 BHK",
    fiveBHKAndAbove: "5 BHK & Above",
    applicantResideAt: "Applicant Reside At",
    locality: "Locality",
    tpc1: "Tpc 1",
    tpcRemarks1: "Tpc Remarks 1",
    tpc2: "Tpc 2",
    tpcRemarks2: "Tpc Remarks 2",
    additionalRemarks: "Additional Remarks",
  },
  HINDI: {
    companyBusinessPriority: "कंपनी / व्यवसाय प्राथमिकता",
    select: "चुनें",
    high: "उच्च",
    moderate: "मध्यम",
    low: "निम्न",
    companyBusinessDescription: "कंपनी / व्यवसाय विवरण",
    visitConducted: "यात्रा की गई",
    yes: "हां",
    no: "नहीं",
    addressConfirmation: "पता पुष्टि",
    ifAddressNotConfirm: "यदि पता पुष्टि नहीं है",
    addressTrace: "पता पता लगाना",
    easy: "आसान",
    notEasy: "कठिन",
    landmark: "सीमाचिह्न",
    metPersonName: "मिली व्यक्ति का नाम",
    metPersonRelation: "मिली व्यक्ति का संबंध",
    ownership: "स्वामित्व",
    ownedByApplicant: "आवेदक द्वारा स्वामित्व",
    parental: "माता-पिता",
    rented: "किराए पर",
    married: "विवाहित",
    unmarried: "अविवाहित",
    zero: "0",
    one: "1",
    two: "2",
    three: "3",
    four: "4",
    fiveAndAbove: "5 और ऊपर",
    ifRented: "यदि किराए पर (किराए की राशि और मकान मालिक का नाम)",
    stabilityYears: "स्थिरता के वर्ष",
    maritalStatus: "वैवाहिक स्थिति",
    child: "बच्चा",
    totalMembers: "कुल सदस्य",
    earningMembers: "कमाने वाले सदस्य",
    spouseName: "पति/पत्नी का नाम",
    standardOfLiving: "जीवन स्तर का चयन करें",
    average: "औसत",
    seen: "देखा",
    notSeen: "नहीं देखा",
    namePlate: "नाम पट्टिका",
    totalRoom: "कुल कमरा",
    oneBHK: "1 बीएचके",
    twoBHK: "2 बीएचके",
    threeBHK: "3 बीएचके",
    fourBHK: "4 बीएचके",
    fiveBHKAndAbove: "5 बीएचके और ऊपर",
    applicantResideAt: "आवेदक निवास करता है",
    locality: "स्थानीयता",
    tpc1: "टीपीसी 1",
    tpcRemarks1: "टीपीसी टिप्पणी 1",
    tpc2: "टीपीसी 2",
    tpcRemarks2: "टीपीसी टिप्पणी 2",
    additionalRemarks: "अतिरिक्त टिप्पणी",
  },
  GUJARATI: {
    companyBusinessPriority: "કંપની / બિઝનેસ પ્રાથમિકતા",
    select: "પસંદ કરો",
    high: "ઉચ્ચ",
    moderate: "મધ્યમ",
    low: "નિમ્ન",
    companyBusinessDescription: "કંપની/વ્યવસાયનું વર્ણન",
    visitConducted: "મુલાકાત લીધી",
    yes: "હા",
    no: "ના",
    addressConfirmation: "સરનામાંની પુષ્ટિ",
    ifAddressNotConfirm: "જો એડ્રેસ કન્ફર્મ નથી",
    addressTrace: "સરનામું મળ્યું",
    easy: "સહજ",
    notEasy: "મુશ્કેલ",
    landmark: "લેન્ડમાર્ક",
    metPersonName: "જે વ્યક્તિ ને મળ્યા એનું નામ",
    metPersonRelation: "જે વ્યક્તિ ને મળ્યા એનો સંબંધ",
    ownership: "માલિકી",
    ownedByApplicant: "અરજદાર દ્વારા માલિકી",
    parental: "પિતૃત્વ",
    rented: "ભાડે",
    married: "વિવાહિત",
    unmarried: "અવિવાહિત",
    zero: "0",
    one: "1",
    two: "2",
    three: "3",
    four: "4",
    fiveAndAbove: "5 અને ઉપર",
    ifRented: "જો ભાડે હોય તો(ભાડુ અને મકાનમલિક નો નંબર  )",
    stabilityYears: "કેટલા વર્ષો થી સ્થાયી છે",
    maritalStatus: "વૈવાહિક સ્થિતિ",
    child: "બાળક",
    totalMembers: "કુલ સભ્યો",
    earningMembers: "કમાતા સભ્યો",
    spouseName: "જીવનસાથીનું નામ",
    standardOfLiving: "સ્ટાન્ડર્ડ ઓફ લિવિંગ પસંદ કરો ",
    average: "સરેરાશ",
    seen: "જુઓ",
    notSeen: "જુઓ નથી",
    namePlate: "નેમ પ્લેટ",
    totalRoom: "કુલ રૂમ",
    oneBHK: "1 BHK",
    twoBHK: "2 BHK",
    threeBHK: "3 BHK",
    fourBHK: "4 BHK",
    fiveBHKAndAbove: "5 BHK & ઉપર",
    applicantResideAt: "borrower રહે એ સ્થાન",
    locality: "લોકાલિટી",
    tpc1: "Tpc 1",
    tpcRemarks1: "Tpc Remarks 1",
    tpc2: "Tpc 2",
    tpcRemarks2: "Tpc Remarks 2",
    additionalRemarks: "વધારાની ટિપ્પણીઓ",
  }
};

export default function Page3Residence() {
  const navigate = useNavigate();
  const [cpvLanguage, setCpvLanguage] = useState("ENGLISH");

  useEffect(() => {
    const language = localStorage.getItem("cpvLanguage");
    console.log(language)
    setCpvLanguage(language);
  }, []);

  const [companyBusinessPriority, setCompanyBusinessPriority] = useState("");
  const [companyBusinessDescription, setCompanyBusinessDescription] = useState("");
  const [visitConducted, setVisitConducted] = useState("");
  const [addressConfirmation, setAddressConfirmation] = useState("");
  const [ifAddressNotConfirm, setIfAddressNotConfirm] = useState("");
  const [addressTrace, setAddressTrace] = useState("");
  const [landmark, setLandmark] = useState("");
  const [metPersonName, setMetPersonName] = useState("");
  const [metPersonRelation, setMetPersonRelation] = useState("");
  const [ownership, setOwnership] = useState("");
  const [ifRented, setIfRented] = useState("");
  const [stabilityYears, setStabilityYears] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [child, setChild] = useState("");
  const [totalMembers, setTotalMembers] = useState("");
  const [earningMembers, setEarningMembers] = useState("");
  const [spouseName, setSpouseName] = useState("");
  const [standardOfLiving, setStandardOfLiving] = useState("");
  const [namePlate, setNamePlate] = useState("");
  const [totalRoom, setTotalRoom] = useState("");
  const [applicantResideAt, setApplicantResideAt] = useState("");
  const [locality, setLocality] = useState("");
  const [tpc1, setTpc1] = useState("");
  const [tpcRemarks1, setTpcRemarks1] = useState("");
  const [tpc2, setTpc2] = useState("");
  const [tpcRemarks2, setTpcRemarks2] = useState("");
  const [additionalRemarks, setAdditionalRemarks] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("CompanyBusinessPriorityCPV", companyBusinessPriority);
    localStorage.setItem(
      "CompanyBusinessDescriptionCPV",
      companyBusinessDescription
    );
    localStorage.setItem("VisitConductedCPV", visitConducted);
    localStorage.setItem("AddressConfirmationCPV", addressConfirmation);
    localStorage.setItem("IfAddressNotConfirmCPV", ifAddressNotConfirm);
    localStorage.setItem("AddressTraceCPV", addressTrace);
    localStorage.setItem("LandmarkCPV", landmark);
    localStorage.setItem("MetPersonNameCPV", metPersonName);
    localStorage.setItem("MetPersonRelationCPV", metPersonRelation);
    localStorage.setItem("OwnershipCPV", ownership);
    localStorage.setItem("IfRentedCPV", ifRented);
    localStorage.setItem("StabilityYearsCPV", stabilityYears);
    localStorage.setItem("MaritalStatusCPV", maritalStatus);
    localStorage.setItem("ChildCPV", child);
    localStorage.setItem("TotalMembersCPV", totalMembers);
    localStorage.setItem("EarningMembersCPV", earningMembers);
    localStorage.setItem("SpouseNameCPV", spouseName);
    localStorage.setItem("StandardOfLivingCPV", standardOfLiving);
    localStorage.setItem("NamePlateCPV", namePlate);
    localStorage.setItem("TotalRoomCPV", totalRoom);
    localStorage.setItem("ApplicantResideAtCPV", applicantResideAt);
    localStorage.setItem("LocalityCPV", locality);
    localStorage.setItem("Tpc1CPV", tpc1);
    localStorage.setItem("TpcRemarks1CPV", tpcRemarks1);
    localStorage.setItem("Tpc2CPV", tpc2);
    localStorage.setItem("TpcRemarks2CPV", tpcRemarks2);
    localStorage.setItem("AdditionalRemarksCPV", additionalRemarks);
    setTimeout(() => {
      navigate("/4");
    }, 2000);
  };

  return (
    <div className="main-login">
      <div style={{ margin: "2rem" }}>
        <img src={Credin} alt="Credin Logo" width="150" />
      </div>
      <div className="container-login">
        <div
          style={{
            fontWeight: "bolder",
            fontSize: "1.5rem",
            margin: ".5rem 0",
          }}
        >
          Interview Details
        </div>
        <form onSubmit={handleSubmit}>
          <div className="div-login">
            {/* <label>
              Company / Business Priority{" "}
              <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].companyBusinessPriority} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="company-business-priority"
              required
              value={companyBusinessPriority}
              onChange={(e) => setCompanyBusinessPriority(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="High">{translations[cpvLanguage].high}</option>
              <option value="Moderate">{translations[cpvLanguage].moderate}</option>
              <option value="Low">{translations[cpvLanguage].low}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Company/ Business Description{" "}
              <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].companyBusinessDescription} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="company-business-description"
              required
              value={companyBusinessDescription}
              onChange={(e) => setCompanyBusinessDescription(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Visit Conducted <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].visitConducted} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="visit-conducted"
              value={visitConducted}
              required
              onChange={(e) => setVisitConducted(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Yes">{translations[cpvLanguage].yes}</option>
              <option value="No">{translations[cpvLanguage].no}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Address Confirmation <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].addressConfirmation} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="address-confirmation"
              value={addressConfirmation}
              onChange={(e) => setAddressConfirmation(e.target.value)}
              required
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Yes">{translations[cpvLanguage].yes}</option>
              <option value="No">{translations[cpvLanguage].no}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              If Address Not Confirm <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].ifAddressNotConfirm}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="if-address-not-confirmed"
              value={ifAddressNotConfirm}
              onChange={(e) => setIfAddressNotConfirm(e.target.value)}
              required
            />
          </div>
          <div className="div-login">
            {/* <label>
              Address Trace <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].addressTrace}<span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="address-trace"
              value={addressTrace}
              onChange={(e) => setAddressTrace(e.target.value)}
              required
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Easy">{translations[cpvLanguage].easy}</option>
              <option value="Not Easy">{translations[cpvLanguage].notEasy}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Landmark <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].landmark}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="landmark"
              value={landmark}
              onChange={(e) => setLandmark(e.target.value)}
              required
            />
          </div>
          <div className="div-login">
            {/* <label>
              Met Person Name <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].metPersonName}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="met-person-name"
              required
              value={metPersonName}
              onChange={(e) => setMetPersonName(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Met Person Relation <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].metPersonRelation} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="met-person-relation"
              required
              value={metPersonRelation}
              onChange={(e) => setMetPersonRelation(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Ownership <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].ownership} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="ownership"
              required
              value={ownership}
              onChange={(e) => setOwnership(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Owned By Applicant">{translations[cpvLanguage].ownedByApplicant}</option>
              <option value="Parental">{translations[cpvLanguage].parental}</option>
              <option value="Rented">{translations[cpvLanguage].rented}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              If Rented (Rent Amt. & Landlord Name){" "}
              <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].ifRented} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="if-rented"
              required
              value={ifRented}
              onChange={(e) => setIfRented(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Stability Years <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].stabilityYears} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="stability-years"
              required
              value={stabilityYears}
              onChange={(e) => setStabilityYears(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Marital Status <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].maritalStatus} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="marital-status"
              required
              value={maritalStatus}
              onChange={(e) => setMaritalStatus(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Married">{translations[cpvLanguage].married}</option>
              <option value="Unmarried">{translations[cpvLanguage].unmarried}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Child <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].child} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="child"
              required
              value={child}
              onChange={(e) => setChild(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5 & Above">5 & Above</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Total Members <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].totalMembers} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="total-members"
              required
              value={totalMembers}
              onChange={(e) => setTotalMembers(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5 & Above">5 & Above</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Earning Members <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].earningMembers} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="earning-members"
              required
              value={earningMembers}
              onChange={(e) => setEarningMembers(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5 & Above">5 & Above</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Spouse Name <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].spouseName} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="spouse-name"
              required
              value={spouseName}
              onChange={(e) => setSpouseName(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Select Standard Of Living <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].standardOfLiving} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="standard-of-living"
              required
              value={standardOfLiving}
              onChange={(e) => setStandardOfLiving(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="High">{translations[cpvLanguage].high}</option>
              <option value="Average">{translations[cpvLanguage].average}</option>
              <option value="Low">{translations[cpvLanguage].low}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Name Plate <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].namePlate} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="name-plate"
              required
              value={namePlate}
              onChange={(e) => setNamePlate(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Seen">{translations[cpvLanguage].seen}</option>
              <option value="Not Seen">{translations[cpvLanguage].notSeen}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Total Room <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].totalRoom} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="total-room"
              required
              value={totalRoom}
              onChange={(e) => setTotalRoom(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="1 BHK">{translations[cpvLanguage].oneBHK}</option>
              <option value="2 BHK">{translations[cpvLanguage].twoBHK}</option>
              <option value="3 BHK">{translations[cpvLanguage].threeBHK}</option>
              <option value="4 BHK">{translations[cpvLanguage].fourBHK}</option>
              <option value="5 BHK & Above">{translations[cpvLanguage].fiveBHKAndAbove}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Applicant Reside At <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].applicantResideAt} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="applicant-reside-at"
              required
              value={applicantResideAt}
              onChange={(e) => setApplicantResideAt(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Locality <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].locality} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              value={locality}
              name="locality"
              required
              onChange={(e) => setLocality(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="High">{translations[cpvLanguage].high}</option>
              <option value="Average">{translations[cpvLanguage].average}</option>
              <option value="Low">{translations[cpvLanguage].low}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Tpc 1 <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpc1} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="tpc-1"
              required
              value={tpc1}
              onChange={(e) => setTpc1(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Tpc Remarks 1 <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpcRemarks1} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="tpc-remarks-1"
              required
              value={tpcRemarks1}
              onChange={(e) => setTpcRemarks1(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Tpc 2 <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpc2} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="tpc-2"
              required
              value={tpc2}
              onChange={(e) => setTpc2(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Tpc Remarks 2 <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpcRemarks2} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="tpc-remarks-2"
              required
              value={tpcRemarks2}
              onChange={(e) => setTpcRemarks2(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Additional Remarks <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].additionalRemarks} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="additional-remarks"
              required
              value={additionalRemarks}
              onChange={(e) => setAdditionalRemarks(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: ".5rem",
            }}
          >
            <button className="btn-login" type="submit">
              Proceed
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
